// Billing · single-plan card. Split out from BillingTab so plan-comparison
// rendering can evolve without touching checkout / polling logic.
import React from "react";
import { Card } from "../ui/card";
import { Button } from "../ui/button";
import { Check } from "lucide-react";

const PLAN_FEATURES = {
  starter:      ["1 country", "1 business function", "Unique link + QR", "Lead capture", "Email support"],
  professional: ["Multiple countries", "Multiple functions", "Full Executive Growth Report™", "PDF download", "Priority support"],
  enterprise:   ["Custom branding", "White-label reports", "Branded subdomain", "Custom templates", "Dedicated success"],
};

const planName = (p) => p[0].toUpperCase() + p.slice(1);

export default function PlanCard({ plan, monthly, lifetime, isCurrent, busy, onCheckout }) {
  return (
    <Card className={`card-elevated p-7 ${plan === "professional" ? "ring-1 ring-accent" : ""}`} data-testid={`billing-plan-${plan}`}>
      {plan === "professional" && (
        <div className="text-[10px] uppercase tracking-widest bg-accent text-accent-foreground inline-block px-2 py-0.5 rounded-full mb-3 font-semibold">
          Most popular
        </div>
      )}
      <div className="overline">{planName(plan)}</div>
      <div className="mt-3 flex items-end gap-2">
        <div className="font-display text-5xl">${monthly?.amount}</div>
        <div className="text-muted-foreground pb-2">/month</div>
      </div>
      <div className="text-sm text-muted-foreground mt-1">or ${lifetime?.amount} lifetime</div>

      <ul className="mt-6 space-y-3">
        {(PLAN_FEATURES[plan] || []).map((f) => (
          <li key={f} className="flex items-start gap-2 text-sm">
            <Check className="w-4 h-4 text-accent mt-0.5 shrink-0" />
            <span>{f}</span>
          </li>
        ))}
      </ul>

      <div className="mt-7 flex flex-col gap-2">
        <Button
          data-testid={`buy-monthly-${plan}`}
          disabled={!!busy || isCurrent}
          onClick={() => onCheckout(monthly.id)}
          className="bg-accent text-accent-foreground hover:bg-accent/90 rounded-full"
        >
          {busy === monthly?.id ? "Redirecting…" : isCurrent ? "Current plan" : `Subscribe — $${monthly?.amount}/mo`}
        </Button>
        <Button
          data-testid={`buy-lifetime-${plan}`}
          disabled={!!busy}
          onClick={() => onCheckout(lifetime.id)}
          variant="outline"
          className="rounded-full"
        >
          {busy === lifetime?.id ? "Redirecting…" : `Buy lifetime — $${lifetime?.amount}`}
        </Button>
      </div>
    </Card>
  );
}
